/* TITLE Auto-Setter (Persistente)
   - IMG: si <img> tiene alt y no tiene title => title = alt
   - A: si <a> no tiene title => title = aria-label (si existe) o texto visible
   - Re-aplica cuando el DOM cambia (AJAX/apps/cart drawer/quick view)
   - No sobrescribe titles existentes
*/
(function () {
  if (window.__titleAutoSetterInstalled) return;
  window.__titleAutoSetterInstalled = true;

  function normalize(str) {
    return (str || '').replace(/\s+/g, ' ').trim();
  }

  function applyTitles(root) {
    var scope = root || document;

    // IMG: ALT -> TITLE
    scope.querySelectorAll('img[alt]').forEach(function (img) {
      var alt = normalize(img.getAttribute('alt'));
      if (!alt) return;

      var title = normalize(img.getAttribute('title'));
      if (!title) img.setAttribute('title', alt);
    });

    // LINKS: TITLE desde aria-label o texto
    scope.querySelectorAll('a').forEach(function (a) {
      var title = normalize(a.getAttribute('title'));
      if (title) return;

      var aria = normalize(a.getAttribute('aria-label'));
      if (aria) {
        a.setAttribute('title', aria);
        return;
      }

      var text = normalize(a.textContent);
      if (text) a.setAttribute('title', text);
    });
  }

  // Ejecuta al inicio + al cargar
  applyTitles(document);
  document.addEventListener('DOMContentLoaded', function () { applyTitles(document); });
  window.addEventListener('load', function () { applyTitles(document); });

  // Reaplica con cambios de DOM (AJAX)
  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyTitles(document);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
        scheduleApply();
        break;
      }
      if (m.type === 'attributes') {
        var name = m.attributeName;
        if (name === 'alt' || name === 'aria-label' || name === 'title') {
          scheduleApply();
          break;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['alt', 'aria-label', 'title']
  });

  // Shopify Theme Editor
  document.addEventListener('shopify:section:load', scheduleApply);
  document.addEventListener('shopify:section:reorder', scheduleApply);
  document.addEventListener('shopify:section:select', scheduleApply);
})();